/**
 * Created by Carlos on 11/07/2026.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('promotionCtrl', promotionCtrl)
        .controller('modalAddUserCtrl', modalAddUserCtrl);

    promotionCtrl.$inject = ['$uibModal','tabs','datePickerService',
        'linkService','printService','oneService','$stateParams','paginationService','messageService','userSession','$translate','CONFIG'];

    //-----------------MODALS
    modalAddUserCtrl.$inject = ['linkService','$uibModal','$uibModalInstance','oneService','userSession','userPushHtmlSelected','messageService','CONFIG','channel'/*,'assignAirCrewService', 'occupationCrewCharges','occupationCommandCrewCharges','indexX','assignForms','$timeout','messageService'*/];

    function promotionCtrl($uibModal, tabs, datePickerService, linkService,printService, oneService, $stateParams, paginationService, messageService, userSession, $translate, CONFIG) {
        var vm = this;
        vm.$uibModal = $uibModal;
        vm.promotion = {
            active: false
        };
        vm.userPushHtml = [];

        vm.userSession = userSession.data;
        vm.showFormPush = false;

        vm.selectCheckBoxChannel = {};
        vm.tabs = tabs;
        vm.pages = paginationService.getPages();
        vm.isReport = false;
        vm.reportClassAvailabilityHtml = '';
        vm.searchBy = $stateParams.searchBy;
        loadChannels();

        vm.cancelPromotion = function(){
            linkService.reloadRoute('promotions', null);
        }

        function loadChannels() {
            oneService.findChannel(vm.userSession.login)
                .then(function (response) {
                    vm.channels = [];
                    if(response.data.length > 0) {
                        vm.channels = response.data;
                    } else {
                        messageService.registerDeleteGeneralError('promotions','air.promotion.thereIsNoInformation');
                    }
                });
        }

        vm.addUserByAttr = function (userPushHtml) {
            if( vm.channels.channel === undefined ) {
                messageService.registerDeleteGeneralError('promotions','air.promotion.selectChannel');
            } else {
                var modalInstance = vm.$uibModal.open({
                    templateUrl: 'app/admin/configGeneral/message/promotion/addUserForm.html',
                    controller: 'modalAddUserCtrl',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        userSession:['userService',function(userService){
                            return userService.getSession(true);
                        }],
                        channel: [function() {
                            return vm.channels.channel;
                        }],
                        userPushHtmlSelected: [function() {
                            return userPushHtml;
                        }]
                    }
                });
                modalInstance.result.then(function (response) {
                    if(response !== undefined){
                        vm.userPushHtml = response
                    }
                }, function () {
                });
            }
        }

        vm.deleteUserPush = function(index){
            vm.userPushHtml.splice(index, 1);
        }

        vm.formPromotionValid =  function(isValid) {
            if (isValid) {
                if( vm.userPushHtml.length === 0 && vm.promotion.active) {
                    messageService.registerDeleteGeneralError('promotions','air.promotion.oneUser');
                } else {
                    if(vm.promotion.active) {
                        var save = {
                            "title": vm.promotion.title,
                            "message": vm.promotion.msg,
                            "domainId": CONFIG.DOMAIN_ID_APP,
                            "userDetails": []
                        }
                        if(vm.promotion.url !== undefined && vm.promotion.url.trim().length >0) save.dataTemplate = '{"link":"' + new URL(vm.promotion.url.trim()) + '"}';
                        var tokens=[];
                        for(var j=0; j < vm.userPushHtml.length; j++) {
                            oneService.getSearchByData(CONFIG.DOMAIN_ID_APP, vm.channels.channel.code, vm.userPushHtml[j].nroIdentity, false, vm.userSession.login).then(function (response) {
                                for (var i = 0; i < response.data.length; i++) {
                                    var urs = response.data[i];
                                    tokens.push(urs)
                                }
                                save.userDetails = tokens;
                                oneService.sendDataReportPost("DIRECT", save).then(function (response) {
                                    messageService.successMsg('air.promotion.successMsg');
                                    linkService.reloadRoute('promotions', null);
                                });
                            });
                        }
                    } else {
                        var save = {
                            "title": vm.promotion.title,
                            "message": vm.promotion.msg,
                            "isTravelConnect": false,
                            "domainId": CONFIG.DOMAIN_ID_APP
                        }
                        if(vm.promotion.url !== undefined && vm.promotion.url.trim().length >0) save.dataTemplate = '{"link":"' + new URL(vm.promotion.url.trim()) + '"}';
                        oneService.sendDataReportPost("ALL", save).then(function (response) {
                            messageService.successMsg('air.promotion.successMsg');
                            linkService.reloadRoute('promotions', null);
                        });

                    }
                }
            }
        }
        vm.changeRadio = function(option) {
            vm.promotion.active = option;
            if(!option) vm.userPushHtml = [];
        }
    }

    function modalAddUserCtrl(linkService,$uibModal,$uibModalInstance,oneService,userSession,userPushHtmlSelected,messageService,CONFIG,channel) {
        var vm = this;
        vm.showUser = false;
        vm.showUserPopup = false;
        vm.userSession = userSession.data;
        vm.search = '';
        vm.userHtml = userPushHtmlSelected;
        vm.closeDialogPromotion = function () {
            $uibModalInstance.close();
        }
        vm.searchByData = function () {
            if(vm.search !== undefined && vm.search.trim().length > 0) {
                oneService.getSearchByData(CONFIG.DOMAIN_ID_APP, channel.code, vm.search, false, vm.userSession.login)
                    .then(function (response) {
                        vm.users = [];
                        if(response.data.length > 0) {
                            var ur;
                            var previous=0;
                            var j = 0
                            for (var i = 0; i < response.data.length; i++){
                                if(response.data[i].userId != previous && j !=0 ) {
                                    vm.users.push(ur);
                                }
                                ur = response.data[i];
                                previous = ur.userId;
                                j++;
                            }
                            if( j>0 ) {
                                vm.users.push(ur);
                                vm.showUserPopup = true;
                            }
                        } else {
                            messageService.registerDeleteGeneralError('promotions','air.promotion.thereIsNoInformation');
                        }
                    });
            }
        }

        vm.addUserPush = function (isValid, user) {
            if (isValid) {
                if(user !== undefined) {
                    if(vm.userHtml.length == 0) {
                        vm.userHtml.push(user);
                    } else {
                        var repeat = false;
                        vm.userHtml.forEach(function(usr) {
                            if(usr.userId == user.userId) {
                                repeat = true;
                            }
                        });
                        if(!repeat) {
                            vm.userHtml.push(user);
                        } else {
                            messageService.registerDeleteGeneralError('promotions','air.promotion.duplicated');
                        }
                    }
                    $uibModalInstance.close(vm.userHtml);
                } else {
                    messageService.registerDeleteGeneralError('promotions','air.promotion.pushSearch');
                }
            }
        };
    }

})();
